export default __webpack_public_path__ + "static/media/af-no-text-logo.89bf4fbb.svg";